<template>
  <div v-if="articleLabels && articleLabels.length">
    <div class="content-item flex">
      <el-row>
        <el-col :span="12">
          <div class="top-wrap">
            <el-tooltip
              effect="dark"
              :disabled="articleLabels[0]?.name.length < 6"
              :content="articleLabels[0]?.name"
              placement="top"
            >
              <p
                class="content-item-label"
                style="max-width: 107px; height: 40px"
              >
                <span v-if="app_type == 'man'">
                  <span
                    :style="{
                      marginLeft:
                        articleLabels[0]?.name.length > 6 ? '10px' : '0',
                    }"
                    class="eye-gray"
                    v-if="[3, 4].includes(articleLabels[0]?.invisibleStatus)"
                  ></span>
                </span>
                <span
                  :style="{
                    marginLeft: articleLabels[0].name.length > 6 ? '10px' : '0',
                  }"
                  class="eye-gray"
                  v-if="
                    app_type == 'user' && articleLabels[0].invisibleStatus == 3
                  "
                ></span>
                {{ "运营标签" }}
              </p>
            </el-tooltip>
            <el-cascader
              v-if="app_type == 'man' || articleLabels[0].invisibleStatus !== 4"
              class="select-role"
              :options="articleLabels"
              v-model="labelValue"
              :props="{
                multiple: true,
                value: 'id',
                label: 'name',
                children: 'contentLabels',
                checkStrictly: true,
              }"
              @visible-change="visibleChange"
              :show-all-levels="false"
              @change="cascaderChange(...arguments, articleLabels[0], 0)"
            >
              <template slot-scope="{ data }">
                <el-tooltip
                  :disabled="data.name.length < 18"
                  class="item"
                  effect="dark"
                  :content="data.name"
                  placement="top"
                >
                  <span>{{ data.name }}</span>
                </el-tooltip>
              </template>
            </el-cascader>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="large-tab-wrap">
            <span
              :class="lItem.isSelected ? 'large-tab selected' : 'large-tab'"
              v-for="(lItem, labelIndex) in getLargeModelForItem(
                articleLabels[0]
              )"
              :key="labelIndex"
              @click="clickLargeModel(lItem, 0)"
            >
              <i
                :class="lItem.isSelected ? `el-icon-check` : `el-icon-plus`"
              ></i>
              {{ lItem.labelValue }}
            </span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { request } from "@/utils/axios";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "articleLabel",
  props: [
    "articleId",
    "functionIds",
    "labelType",
    "largeModelLabelBizDTOS",
    "labelGroupId",
  ],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
      largeModelLabels: [],
    };
  },
  async created() {
    if (app_type == "user") {
      try {
        this.getListContentUserLabels();
      } catch (e) {
        console.log(e);
      }
    }

    if (app_type == "man") {
      try {
        this.listContentLabelsForAudit();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    cascaderChange(value, item, index) {
      const changeLabelValue = this.labelValue[index];
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
          if (changeLabelValue.length > 0) {
            const findRes = changeLabelValue?.find((cItem) => {
              return cItem.includes(lItem.labelId);
            });
            if (findRes) {
              lItem.isSelected = true;
            } else {
              lItem.isSelected = false;
            }
          } else {
            lItem.isSelected = false;
          }
        }
        return lItem;
      });
      // 触发 label-change 事件，并传递 labelValue
      this.$emit("label-change", this.labelValue);
      console.log("==== debug label-change", this.labelValue);
    },
    clickLargeModel(lItem, index) {
      lItem.isSelected = !lItem.isSelected;
      if (lItem.isSelected) {
        let item = this.articleLabels[index];
        let valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.id == lItem.labelId) {
            valueId = [dataOne.id];
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels.map((dataTwo) => {
              if (dataTwo.id == lItem.labelId) {
                valueId = [dataOne.id, dataTwo.id];
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.id == lItem.labelId) {
                    valueId = [dataOne.id, dataTwo.id, three.id];
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.id == lItem.labelId) {
                        valueId = [dataOne.id, dataTwo.id, three.id, four.id];
                      }
                    });
                  }
                });
              }
            });
          }
        });
        // labelValue 对应位置上添加
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            labelVal = [...labelVal, valueId];
          }
          return labelVal;
        });
      } else {
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
          }
          return labelVal;
        });
      }
      console.log(this.labelValue, "ppppppp11111111");
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          if (!lItem.isSelected) {
            lItem.isSelected = true;
            //  通过labelGroupId找到大模型对应哪一行 改变label
            let index = this.articleLabels.findIndex((aItem) => {
              if (this.$commonJs.getTenantId() == 290) {
                return aItem.id == lItem?.commonLabelBizDTO.labelGroupId;
              }
              return aItem.id == lItem.commonLabelBizDTO.firstPid;
            });
            if (index != -1) {
              console.log(
                index,
                this.articleLabels,
                "11111ppppppppppppp---------->点击了了了",
                lItem
              );
              let item = this.articleLabels[index];
              let valueId = [];
              if (item.contentLabels) {
                item.contentLabels = item.contentLabels;
              }
              // 第一级
              item?.contentLabels?.map((dataOne) => {
                if (dataOne.id == lItem.labelId) {
                  valueId = [dataOne.id];
                }
                // 第二级
                if (dataOne.contentLabels) {
                  dataOne.contentLabels.map((dataTwo) => {
                    if (dataTwo.id == lItem.labelId) {
                      valueId = [dataOne.id, dataTwo.id];
                    }
                    // 第三级
                    if (dataTwo.contentLabels) {
                      dataTwo.contentLabels.map((three) => {
                        if (three.id == lItem.labelId) {
                          valueId = [dataOne.id, dataTwo.id, three.id];
                        }
                        if (three.contentLabels) {
                          three.contentLabels.map((four) => {
                            if (four.id == lItem.labelId) {
                              valueId = [
                                dataOne.id,
                                dataTwo.id,
                                three.id,
                                four.id,
                              ];
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
              // labelValue 对应位置上添加
              this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
                if (labelIndex == index) {
                  labelVal = [...labelVal, valueId];
                }
                return labelVal;
              });
            }
          }
          return lItem;
        });
      } else {
        console.log("pppp");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          lItem.isSelected = false;
          this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
            return labelVal;
          });
          return lItem;
        });
      }
    },
    visibleChange(val) {
      if (val) {
        //此处可以出来选中下拉选项，清空input搜索值
      }
      this.$nextTick(() => {
        // 添加这段代码
        const $el = document.querySelectorAll(
          ".el-cascader-panel .el-cascader-node[aria-owns]"
        );
        Array.from($el).map((item) => item.removeAttribute("aria-owns"));
      });
    },
    getFormLabelData(form) {
      let newList = []; // 原始数据
      let numList = []; // 选择的id
      // 整合原始数据
      this.articleLabels?.map((item) => {
        // 一级数据
        newList.push(item);
        item?.contentLabels?.map((oneItem) => {
          if (oneItem.contentLabels) {
            // 二级数据
            if (oneItem.contentLabels) {
              oneItem.contentLabels.map((twoItme) => {
                newList.push(twoItme);
                // 三级数据
                if (twoItme.contentLabels) {
                  twoItme.contentLabels.map((threeItem) => {
                    newList.push(threeItem);
                    // 四级数据
                    if (threeItem.contentLabels) {
                      threeItem.contentLabels.map((fourItem) => {
                        newList.push(fourItem);
                        if (fourItem?.contentLabels) {
                          threeItem?.contentLabels.map((fifthItem) => {
                            newList.push(fifthItem);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          }
          newList.push(oneItem);
        });
      });
      // 选择的id
      this.labelValue?.map((item) => {
        if (item.length == 2) {
          numList.push(item[1]);
        } else if (item.length == 3) {
          numList.push(item[2]);
        } else if (item.length == 4) {
          numList.push(item[3]);
        } else if (item.length == 5) {
          numList.push(item[4]);
        } else {
          numList.push(item[0]);
        }
      });
      // 新增和回显数据
      form.extensionContentLabels = [];
      newList?.map((item) => {
        numList.map((idItme) => {
          if (item.id == idItme) {
            // todo
            // const { contentLabels, ...itemWithoutContentLabels } = item;
            form.extensionContentLabels.push(item);
          }
        });
      });
    },
    // 创作者端 -------- 获取标签组信息
    async getListContentUserLabels() {
      let res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId || "",
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ getListContentUserLabels ~ res: 343 ", res);
      console.log("======??", res);
      let initData = [];
      if (this.labelType) {
        res.forEach((item) => {
          initData = initData.concat(...item.contentLabels);
        });
      }
      this.articleLabels = this.labelType ? initData : res.data;
      console.log(initData, this.articleLabels, "====---------------->", res);
      this.articleLabels &&
        this.articleLabels.forEach((oneLevel) => {
          oneLevel.valueId = [];
          // if (oneLevel.contentLabels) {
          // oneLevel.contentLabels = oneLevel.contentLabels
          // }
          oneLevel?.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel.contentLabels.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four.contentLabels.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
      // 反显
      this.articleLabels?.map((item) => {
        item.valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.isChecked) {
            item.valueId.push([dataOne.id]);
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels?.map((dataTwo) => {
              if (dataTwo.isChecked) {
                item.valueId.push([dataOne.id, dataTwo.id]);
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.isChecked) {
                    item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.isChecked) {
                        item.valueId.push([
                          dataOne.id,
                          dataTwo.id,
                          three.id,
                          four.id,
                        ]);
                      }
                    });
                  }
                });
              }
            });
          }
        });
        this.labelValue.push(item);
        console.log(this.labelValue, "labelValue------>");
      });
    },
    // 运营端 -------- 获取审核文章时的标签组和标签信息
    async listContentLabelsForAudit() {
      var res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId,
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelGroupId
          ? this.labelGroupId
          : this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ listContentLabelsForAudit ~ res: 449 ", res);
      console.log("======??1", res);
      if (res.code != "1900") {
        let initData = [];
        if (this.labelType) {
          res?.data?.forEach((item) => {
            initData = initData.concat(...item.contentLabels);
          });
        }
        this.articleLabels = this.labelType ? initData : res.data;
        // label
        this.articleLabels?.forEach((oneLevel) => {
          // if (oneLevel.contentLabels) {
          //   oneLevel.contentLabels = oneLevel.contentLabels
          // }
          // 一级
          oneLevel.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = twoLevel?.contentLabels?.length > 0;
              // 二级
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel?.contentLabels?.forEach((three) => {
                  // 子标签长度为0时，删除改子标签字段
                  if (three?.contentLabels?.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel?.contentLabels?.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four?.contentLabels?.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels?.map((item) => {
          item.valueId = [];
          if (item.contentLabels) {
            item.contentLabels = item.contentLabels;
          }
          console.log("======??2", item);
          if (item.isChecked) {
            console.log("======??3", item);
            this.labelValue.push([item.id]);
          }

          // 第一级
          item?.contentLabels?.map((dataOne) => {
            if (dataOne.isChecked) {
              console.log("======??4", dataOne);
              this.labelValue.push([item.id, dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                if (dataTwo.isChecked) {
                  this.labelValue.push([item.id, dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    if (three.isChecked) {
                      this.labelValue.push([
                        item.id,
                        dataOne.id,
                        dataTwo.id,
                        three.id,
                      ]);
                    }
                    if (three.contentLabels) {
                      three.contentLabels.map((four) => {
                        if (four.isChecked) {
                          this.labelValue.push([
                            item.id,
                            dataOne.id,
                            dataTwo.id,
                            three.id,
                            four.id,
                          ]);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          // this.labelValue.push(item.valueId)
          // [ [], [ [ 101573, 101596, 101600, 101697 ], [ 101573, 101596, 101606 ] ], [], [], [], [], [], [], [ [ 10180103, 101619 ] ], [], [], [], [], [], [], [], [] ]
          // this.labelValue = [ [ 101560, 101561 ], [ 101560, 101565, 101567 ], [ 101560, 101565, 101568 ], [ 101573, 101585 ] ]
          // this.labelValue = this.labelValue
          //   .filter(item => item.length > 0) // 过滤掉空数组
          if (item.valueId.length > 0) {
            console.log(
              "item.valueId.length",
              "ppppppppppppppp111",
              this.largeModelLabels.length,
              this.articleLabels.length
            );
            // 匹配大模型
            this.largeModelLabels = this.largeModelLabels.map((lItem) => {
              if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
                // 从大分组中找到单行
                const findRes = item.valueId?.find((cItem) => {
                  return cItem.includes(lItem.labelId);
                });
                if (findRes) {
                  lItem.isSelected = true;
                }
              }
              return lItem;
            });
          }
          //
        });
      } else {
        this.articleLabels = [];
      }
    },
    getLargeModelForItem(item) {
      if (this.$commonJs.getTenantId() == 290) {
        return this.largeModelLabels.filter(
          (lgModel) => lgModel.commonLabelBizDTO.labelGroupId == item.id
        );
      }
      return this.largeModelLabels.filter(
        (lgModel) => lgModel.commonLabelBizDTO.firstPid == item.id
      );
    },
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp11111111",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
    articleLabels(val) {
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp22222",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.eye-gray {
  content: "";
  display: inline-block;
  background: url("~@/assets/eye-gray.png") no-repeat 0 0;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  margin-left: -20px;
  margin-top: -15px;
}

// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 400px !important;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.content-item) {
  min-width: 100% !important;
  flex-direction: column !important;
  .top-wrap {
    display: flex;
    flex-direction: row;
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // margin-left: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>

<script>
import { request } from "@/utils/axios";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "articleLabel",
  props: [
    "articleId",
    "functionIds",
    "labelType",
    "largeModelLabelBizDTOS",
    "labelGroupId",
  ],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
      largeModelLabels: [],
    };
  },
  async created() {
    if (app_type == "user") {
      try {
        this.getListContentUserLabels();
      } catch (e) {
        console.log(e);
      }
    }

    if (app_type == "man") {
      try {
        this.listContentLabelsForAudit();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    cascaderChange(value, item, index) {
      const changeLabelValue = this.labelValue[index];
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
          if (changeLabelValue.length > 0) {
            const findRes = changeLabelValue?.find((cItem) => {
              return cItem.includes(lItem.labelId);
            });
            if (findRes) {
              lItem.isSelected = true;
            } else {
              lItem.isSelected = false;
            }
          } else {
            lItem.isSelected = false;
          }
        }
        return lItem;
      });
      // 触发 label-change 事件，并传递 labelValue
      this.$emit("label-change", this.labelValue);
      console.log("==== debug label-change", this.labelValue);
    },
    clickLargeModel(lItem, index) {
      lItem.isSelected = !lItem.isSelected;
      if (lItem.isSelected) {
        let item = this.articleLabels[index];
        let valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.id == lItem.labelId) {
            valueId = [dataOne.id];
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels.map((dataTwo) => {
              if (dataTwo.id == lItem.labelId) {
                valueId = [dataOne.id, dataTwo.id];
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.id == lItem.labelId) {
                    valueId = [dataOne.id, dataTwo.id, three.id];
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.id == lItem.labelId) {
                        valueId = [dataOne.id, dataTwo.id, three.id, four.id];
                      }
                    });
                  }
                });
              }
            });
          }
        });
        // labelValue 对应位置上添加
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            labelVal = [...labelVal, valueId];
          }
          return labelVal;
        });
      } else {
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
          }
          return labelVal;
        });
      }
      console.log(this.labelValue, "ppppppp11111111");
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          if (!lItem.isSelected) {
            lItem.isSelected = true;
            //  通过labelGroupId找到大模型对应哪一行 改变label
            let index = this.articleLabels.findIndex((aItem) => {
              if (this.$commonJs.getTenantId() == 290) {
                return aItem.id == lItem?.commonLabelBizDTO.labelGroupId;
              }
              return aItem.id == lItem.commonLabelBizDTO.firstPid;
            });
            if (index != -1) {
              console.log(
                index,
                this.articleLabels,
                "11111ppppppppppppp---------->点击了了了",
                lItem
              );
              let item = this.articleLabels[index];
              let valueId = [];
              if (item.contentLabels) {
                item.contentLabels = item.contentLabels;
              }
              // 第一级
              item?.contentLabels?.map((dataOne) => {
                if (dataOne.id == lItem.labelId) {
                  valueId = [dataOne.id];
                }
                // 第二级
                if (dataOne.contentLabels) {
                  dataOne.contentLabels.map((dataTwo) => {
                    if (dataTwo.id == lItem.labelId) {
                      valueId = [dataOne.id, dataTwo.id];
                    }
                    // 第三级
                    if (dataTwo.contentLabels) {
                      dataTwo.contentLabels.map((three) => {
                        if (three.id == lItem.labelId) {
                          valueId = [dataOne.id, dataTwo.id, three.id];
                        }
                        if (three.contentLabels) {
                          three.contentLabels.map((four) => {
                            if (four.id == lItem.labelId) {
                              valueId = [
                                dataOne.id,
                                dataTwo.id,
                                three.id,
                                four.id,
                              ];
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
              // labelValue 对应位置上添加
              this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
                if (labelIndex == index) {
                  labelVal = [...labelVal, valueId];
                }
                return labelVal;
              });
            }
          }
          return lItem;
        });
      } else {
        console.log("pppp");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          lItem.isSelected = false;
          this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
            return labelVal;
          });
          return lItem;
        });
      }
    },
    visibleChange(val) {
      if (val) {
        //此处可以出来选中下拉选项，清空input搜索值
      }
      this.$nextTick(() => {
        // 添加这段代码
        const $el = document.querySelectorAll(
          ".el-cascader-panel .el-cascader-node[aria-owns]"
        );
        Array.from($el).map((item) => item.removeAttribute("aria-owns"));
      });
    },
    getFormLabelData(form) {
      let newList = []; // 原始数据
      let numList = []; // 选择的id
      // 整合原始数据
      this.articleLabels?.map((item) => {
        // 一级数据
        newList.push(item);
        item?.contentLabels?.map((oneItem) => {
          if (oneItem.contentLabels) {
            // 二级数据
            if (oneItem.contentLabels) {
              oneItem.contentLabels.map((twoItme) => {
                newList.push(twoItme);
                // 三级数据
                if (twoItme.contentLabels) {
                  twoItme.contentLabels.map((threeItem) => {
                    newList.push(threeItem);
                    // 四级数据
                    if (threeItem.contentLabels) {
                      threeItem.contentLabels.map((fourItem) => {
                        newList.push(fourItem);
                        if (fourItem?.contentLabels) {
                          threeItem?.contentLabels.map((fifthItem) => {
                            newList.push(fifthItem);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          }
          newList.push(oneItem);
        });
      });
      // 选择的id
      this.labelValue?.map((item) => {
        if (item.length == 2) {
          numList.push(item[1]);
        } else if (item.length == 3) {
          numList.push(item[2]);
        } else if (item.length == 4) {
          numList.push(item[3]);
        } else if (item.length == 5) {
          numList.push(item[4]);
        } else {
          numList.push(item[0]);
        }
      });
      // 新增和回显数据
      form.extensionContentLabels = [];
      newList?.map((item) => {
        numList.map((idItme) => {
          if (item.id == idItme) {
            // todo
            // const { contentLabels, ...itemWithoutContentLabels } = item;
            form.extensionContentLabels.push(item);
          }
        });
      });
    },
    // 创作者端 -------- 获取标签组信息
    async getListContentUserLabels() {
      let res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId || "",
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ getListContentUserLabels ~ res: 343 ", res);
      console.log("======??", res);
      let initData = [];
      if (this.labelType) {
        res.forEach((item) => {
          initData = initData.concat(...item.contentLabels);
        });
      }
      this.articleLabels = this.labelType ? initData : res.data;
      console.log(initData, this.articleLabels, "====---------------->", res);
      this.articleLabels &&
        this.articleLabels.forEach((oneLevel) => {
          oneLevel.valueId = [];
          // if (oneLevel.contentLabels) {
          // oneLevel.contentLabels = oneLevel.contentLabels
          // }
          oneLevel?.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel.contentLabels.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four.contentLabels.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
      // 反显
      this.articleLabels?.map((item) => {
        item.valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.isChecked) {
            item.valueId.push([dataOne.id]);
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels?.map((dataTwo) => {
              if (dataTwo.isChecked) {
                item.valueId.push([dataOne.id, dataTwo.id]);
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.isChecked) {
                    item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.isChecked) {
                        item.valueId.push([
                          dataOne.id,
                          dataTwo.id,
                          three.id,
                          four.id,
                        ]);
                      }
                    });
                  }
                });
              }
            });
          }
        });
        this.labelValue.push(item);
        console.log(this.labelValue, "labelValue------>");
      });
    },
    // 运营端 -------- 获取审核文章时的标签组和标签信息
    async listContentLabelsForAudit() {
      var res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId,
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelGroupId
          ? this.labelGroupId
          : this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ listContentLabelsForAudit ~ res: 449 ", res);
      console.log("======??1", res);
      if (res.code != "1900") {
        let initData = [];
        if (this.labelType) {
          res?.data?.forEach((item) => {
            initData = initData.concat(...item.contentLabels);
          });
        }
        this.articleLabels = this.labelType ? initData : res.data;
        // label
        this.articleLabels?.forEach((oneLevel) => {
          // if (oneLevel.contentLabels) {
          //   oneLevel.contentLabels = oneLevel.contentLabels
          // }
          // 一级
          oneLevel.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = twoLevel?.contentLabels?.length > 0;
              // 二级
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel?.contentLabels?.forEach((three) => {
                  // 子标签长度为0时，删除改子标签字段
                  if (three?.contentLabels?.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel?.contentLabels?.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four?.contentLabels?.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels?.map((item) => {
          item.valueId = [];
          if (item.contentLabels) {
            item.contentLabels = item.contentLabels;
          }
          console.log("======??2", item);
          if (item.isChecked) {
            console.log("======??3", item);
            this.labelValue.push([item.id]);
          }

          // 第一级
          item?.contentLabels?.map((dataOne) => {
            if (dataOne.isChecked) {
              console.log("======??4", dataOne);
              this.labelValue.push([item.id, dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                if (dataTwo.isChecked) {
                  this.labelValue.push([item.id, dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    if (three.isChecked) {
                      this.labelValue.push([
                        item.id,
                        dataOne.id,
                        dataTwo.id,
                        three.id,
                      ]);
                    }
                    if (three.contentLabels) {
                      three.contentLabels.map((four) => {
                        if (four.isChecked) {
                          this.labelValue.push([
                            item.id,
                            dataOne.id,
                            dataTwo.id,
                            three.id,
                            four.id,
                          ]);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          // this.labelValue.push(item.valueId)
          // [ [], [ [ 101573, 101596, 101600, 101697 ], [ 101573, 101596, 101606 ] ], [], [], [], [], [], [], [ [ 10180103, 101619 ] ], [], [], [], [], [], [], [], [] ]
          // this.labelValue = [ [ 101560, 101561 ], [ 101560, 101565, 101567 ], [ 101560, 101565, 101568 ], [ 101573, 101585 ] ]
          // this.labelValue = this.labelValue
          //   .filter(item => item.length > 0) // 过滤掉空数组
          if (item.valueId.length > 0) {
            console.log(
              "item.valueId.length",
              "ppppppppppppppp111",
              this.largeModelLabels.length,
              this.articleLabels.length
            );
            // 匹配大模型
            this.largeModelLabels = this.largeModelLabels.map((lItem) => {
              if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
                // 从大分组中找到单行
                const findRes = item.valueId?.find((cItem) => {
                  return cItem.includes(lItem.labelId);
                });
                if (findRes) {
                  lItem.isSelected = true;
                }
              }
              return lItem;
            });
          }
          //
        });
      } else {
        this.articleLabels = [];
      }
    },
    getLargeModelForItem(item) {
      if (this.$commonJs.getTenantId() == 290) {
        return this.largeModelLabels.filter(
          (lgModel) => lgModel.commonLabelBizDTO.labelGroupId == item.id
        );
      }
      return this.largeModelLabels.filter(
        (lgModel) => lgModel.commonLabelBizDTO.firstPid == item.id
      );
    },
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp11111111",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
    articleLabels(val) {
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp22222",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.eye-gray {
  content: "";
  display: inline-block;
  background: url("~@/assets/eye-gray.png") no-repeat 0 0;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  margin-left: -20px;
  margin-top: -15px;
}

// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 400px !important;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.content-item) {
  min-width: 100% !important;
  flex-direction: column !important;
  .top-wrap {
    display: flex;
    flex-direction: row;
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // margin-left: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>

<script>
import { request } from "@/utils/axios";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "articleLabel",
  props: [
    "articleId",
    "functionIds",
    "labelType",
    "largeModelLabelBizDTOS",
    "labelGroupId",
  ],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
      largeModelLabels: [],
    };
  },
  async created() {
    if (app_type == "user") {
      try {
        this.getListContentUserLabels();
      } catch (e) {
        console.log(e);
      }
    }

    if (app_type == "man") {
      try {
        this.listContentLabelsForAudit();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    cascaderChange(value, item, index) {
      const changeLabelValue = this.labelValue[index];
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
          if (changeLabelValue.length > 0) {
            const findRes = changeLabelValue?.find((cItem) => {
              return cItem.includes(lItem.labelId);
            });
            if (findRes) {
              lItem.isSelected = true;
            } else {
              lItem.isSelected = false;
            }
          } else {
            lItem.isSelected = false;
          }
        }
        return lItem;
      });
      // 触发 label-change 事件，并传递 labelValue
      this.$emit("label-change", this.labelValue);
      console.log("==== debug label-change", this.labelValue);
    },
    clickLargeModel(lItem, index) {
      lItem.isSelected = !lItem.isSelected;
      if (lItem.isSelected) {
        let item = this.articleLabels[index];
        let valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.id == lItem.labelId) {
            valueId = [dataOne.id];
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels.map((dataTwo) => {
              if (dataTwo.id == lItem.labelId) {
                valueId = [dataOne.id, dataTwo.id];
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.id == lItem.labelId) {
                    valueId = [dataOne.id, dataTwo.id, three.id];
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.id == lItem.labelId) {
                        valueId = [dataOne.id, dataTwo.id, three.id, four.id];
                      }
                    });
                  }
                });
              }
            });
          }
        });
        // labelValue 对应位置上添加
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            labelVal = [...labelVal, valueId];
          }
          return labelVal;
        });
      } else {
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
          }
          return labelVal;
        });
      }
      console.log(this.labelValue, "ppppppp11111111");
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          if (!lItem.isSelected) {
            lItem.isSelected = true;
            //  通过labelGroupId找到大模型对应哪一行 改变label
            let index = this.articleLabels.findIndex((aItem) => {
              if (this.$commonJs.getTenantId() == 290) {
                return aItem.id == lItem?.commonLabelBizDTO.labelGroupId;
              }
              return aItem.id == lItem.commonLabelBizDTO.firstPid;
            });
            if (index != -1) {
              console.log(
                index,
                this.articleLabels,
                "11111ppppppppppppp---------->点击了了了",
                lItem
              );
              let item = this.articleLabels[index];
              let valueId = [];
              if (item.contentLabels) {
                item.contentLabels = item.contentLabels;
              }
              // 第一级
              item?.contentLabels?.map((dataOne) => {
                if (dataOne.id == lItem.labelId) {
                  valueId = [dataOne.id];
                }
                // 第二级
                if (dataOne.contentLabels) {
                  dataOne.contentLabels.map((dataTwo) => {
                    if (dataTwo.id == lItem.labelId) {
                      valueId = [dataOne.id, dataTwo.id];
                    }
                    // 第三级
                    if (dataTwo.contentLabels) {
                      dataTwo.contentLabels.map((three) => {
                        if (three.id == lItem.labelId) {
                          valueId = [dataOne.id, dataTwo.id, three.id];
                        }
                        if (three.contentLabels) {
                          three.contentLabels.map((four) => {
                            if (four.id == lItem.labelId) {
                              valueId = [
                                dataOne.id,
                                dataTwo.id,
                                three.id,
                                four.id,
                              ];
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
              // labelValue 对应位置上添加
              this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
                if (labelIndex == index) {
                  labelVal = [...labelVal, valueId];
                }
                return labelVal;
              });
            }
          }
          return lItem;
        });
      } else {
        console.log("pppp");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          lItem.isSelected = false;
          this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
            return labelVal;
          });
          return lItem;
        });
      }
    },
    visibleChange(val) {
      if (val) {
        //此处可以出来选中下拉选项，清空input搜索值
      }
      this.$nextTick(() => {
        // 添加这段代码
        const $el = document.querySelectorAll(
          ".el-cascader-panel .el-cascader-node[aria-owns]"
        );
        Array.from($el).map((item) => item.removeAttribute("aria-owns"));
      });
    },
    getFormLabelData(form) {
      let newList = []; // 原始数据
      let numList = []; // 选择的id
      // 整合原始数据
      this.articleLabels?.map((item) => {
        // 一级数据
        newList.push(item);
        item?.contentLabels?.map((oneItem) => {
          if (oneItem.contentLabels) {
            // 二级数据
            if (oneItem.contentLabels) {
              oneItem.contentLabels.map((twoItme) => {
                newList.push(twoItme);
                // 三级数据
                if (twoItme.contentLabels) {
                  twoItme.contentLabels.map((threeItem) => {
                    newList.push(threeItem);
                    // 四级数据
                    if (threeItem.contentLabels) {
                      threeItem.contentLabels.map((fourItem) => {
                        newList.push(fourItem);
                        if (fourItem?.contentLabels) {
                          threeItem?.contentLabels.map((fifthItem) => {
                            newList.push(fifthItem);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          }
          newList.push(oneItem);
        });
      });
      // 选择的id
      this.labelValue?.map((item) => {
        if (item.length == 2) {
          numList.push(item[1]);
        } else if (item.length == 3) {
          numList.push(item[2]);
        } else if (item.length == 4) {
          numList.push(item[3]);
        } else if (item.length == 5) {
          numList.push(item[4]);
        } else {
          numList.push(item[0]);
        }
      });
      // 新增和回显数据
      form.extensionContentLabels = [];
      newList?.map((item) => {
        numList.map((idItme) => {
          if (item.id == idItme) {
            // todo
            // const { contentLabels, ...itemWithoutContentLabels } = item;
            form.extensionContentLabels.push(item);
          }
        });
      });
    },
    // 创作者端 -------- 获取标签组信息
    async getListContentUserLabels() {
      let res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId || "",
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ getListContentUserLabels ~ res: 343 ", res);
      console.log("======??", res);
      let initData = [];
      if (this.labelType) {
        res.forEach((item) => {
          initData = initData.concat(...item.contentLabels);
        });
      }
      this.articleLabels = this.labelType ? initData : res.data;
      console.log(initData, this.articleLabels, "====---------------->", res);
      this.articleLabels &&
        this.articleLabels.forEach((oneLevel) => {
          oneLevel.valueId = [];
          // if (oneLevel.contentLabels) {
          // oneLevel.contentLabels = oneLevel.contentLabels
          // }
          oneLevel?.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel.contentLabels.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four.contentLabels.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
      // 反显
      this.articleLabels?.map((item) => {
        item.valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.isChecked) {
            item.valueId.push([dataOne.id]);
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels?.map((dataTwo) => {
              if (dataTwo.isChecked) {
                item.valueId.push([dataOne.id, dataTwo.id]);
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.isChecked) {
                    item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.isChecked) {
                        item.valueId.push([
                          dataOne.id,
                          dataTwo.id,
                          three.id,
                          four.id,
                        ]);
                      }
                    });
                  }
                });
              }
            });
          }
        });
        this.labelValue.push(item);
        console.log(this.labelValue, "labelValue------>");
      });
    },
    // 运营端 -------- 获取审核文章时的标签组和标签信息
    async listContentLabelsForAudit() {
      var res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId,
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelGroupId
          ? this.labelGroupId
          : this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ listContentLabelsForAudit ~ res: 449 ", res);
      console.log("======??1", res);
      if (res.code != "1900") {
        let initData = [];
        if (this.labelType) {
          res?.data?.forEach((item) => {
            initData = initData.concat(...item.contentLabels);
          });
        }
        this.articleLabels = this.labelType ? initData : res.data;
        // label
        this.articleLabels?.forEach((oneLevel) => {
          // if (oneLevel.contentLabels) {
          //   oneLevel.contentLabels = oneLevel.contentLabels
          // }
          // 一级
          oneLevel.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = twoLevel?.contentLabels?.length > 0;
              // 二级
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel?.contentLabels?.forEach((three) => {
                  // 子标签长度为0时，删除改子标签字段
                  if (three?.contentLabels?.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel?.contentLabels?.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four?.contentLabels?.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels?.map((item) => {
          item.valueId = [];
          if (item.contentLabels) {
            item.contentLabels = item.contentLabels;
          }
          console.log("======??2", item);
          if (item.isChecked) {
            console.log("======??3", item);
            this.labelValue.push([item.id]);
          }

          // 第一级
          item?.contentLabels?.map((dataOne) => {
            if (dataOne.isChecked) {
              console.log("======??4", dataOne);
              this.labelValue.push([item.id, dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                if (dataTwo.isChecked) {
                  this.labelValue.push([item.id, dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    if (three.isChecked) {
                      this.labelValue.push([
                        item.id,
                        dataOne.id,
                        dataTwo.id,
                        three.id,
                      ]);
                    }
                    if (three.contentLabels) {
                      three.contentLabels.map((four) => {
                        if (four.isChecked) {
                          this.labelValue.push([
                            item.id,
                            dataOne.id,
                            dataTwo.id,
                            three.id,
                            four.id,
                          ]);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          // this.labelValue.push(item.valueId)
          // [ [], [ [ 101573, 101596, 101600, 101697 ], [ 101573, 101596, 101606 ] ], [], [], [], [], [], [], [ [ 10180103, 101619 ] ], [], [], [], [], [], [], [], [] ]
          // this.labelValue = [ [ 101560, 101561 ], [ 101560, 101565, 101567 ], [ 101560, 101565, 101568 ], [ 101573, 101585 ] ]
          // this.labelValue = this.labelValue
          //   .filter(item => item.length > 0) // 过滤掉空数组
          if (item.valueId.length > 0) {
            console.log(
              "item.valueId.length",
              "ppppppppppppppp111",
              this.largeModelLabels.length,
              this.articleLabels.length
            );
            // 匹配大模型
            this.largeModelLabels = this.largeModelLabels.map((lItem) => {
              if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
                // 从大分组中找到单行
                const findRes = item.valueId?.find((cItem) => {
                  return cItem.includes(lItem.labelId);
                });
                if (findRes) {
                  lItem.isSelected = true;
                }
              }
              return lItem;
            });
          }
          //
        });
      } else {
        this.articleLabels = [];
      }
    },
    getLargeModelForItem(item) {
      if (this.$commonJs.getTenantId() == 290) {
        return this.largeModelLabels.filter(
          (lgModel) => lgModel.commonLabelBizDTO.labelGroupId == item.id
        );
      }
      return this.largeModelLabels.filter(
        (lgModel) => lgModel.commonLabelBizDTO.firstPid == item.id
      );
    },
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp11111111",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
    articleLabels(val) {
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp22222",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.eye-gray {
  content: "";
  display: inline-block;
  background: url("~@/assets/eye-gray.png") no-repeat 0 0;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  margin-left: -20px;
  margin-top: -15px;
}

// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 400px !important;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.content-item) {
  min-width: 100% !important;
  flex-direction: column !important;
  .top-wrap {
    display: flex;
    flex-direction: row;
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // margin-left: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>

<script>
import { request } from "@/utils/axios";

var app_type = process.env.VUE_APP_TYPE;

export default {
  name: "articleLabel",
  props: [
    "articleId",
    "functionIds",
    "labelType",
    "largeModelLabelBizDTOS",
    "labelGroupId",
  ],
  data() {
    return {
      articleLabels: [],
      labelValue: [],
      app_type,
      largeModelLabels: [],
    };
  },
  async created() {
    if (app_type == "user") {
      try {
        this.getListContentUserLabels();
      } catch (e) {
        console.log(e);
      }
    }

    if (app_type == "man") {
      try {
        this.listContentLabelsForAudit();
      } catch (e) {
        console.log(e);
      }
    }
  },
  mounted() {
    const $el = document.querySelectorAll(
      ".el-cascader-panel .el-cascader-node[aria-owns]"
    );
    Array.from($el).map((item) => item.removeAttribute("aria-owns"));
  },
  methods: {
    cascaderChange(value, item, index) {
      const changeLabelValue = this.labelValue[index];
      this.largeModelLabels = this.largeModelLabels.map((lItem) => {
        if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
          if (changeLabelValue.length > 0) {
            const findRes = changeLabelValue?.find((cItem) => {
              return cItem.includes(lItem.labelId);
            });
            if (findRes) {
              lItem.isSelected = true;
            } else {
              lItem.isSelected = false;
            }
          } else {
            lItem.isSelected = false;
          }
        }
        return lItem;
      });
      // 触发 label-change 事件，并传递 labelValue
      this.$emit("label-change", this.labelValue);
      console.log("==== debug label-change", this.labelValue);
    },
    clickLargeModel(lItem, index) {
      lItem.isSelected = !lItem.isSelected;
      if (lItem.isSelected) {
        let item = this.articleLabels[index];
        let valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.id == lItem.labelId) {
            valueId = [dataOne.id];
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels.map((dataTwo) => {
              if (dataTwo.id == lItem.labelId) {
                valueId = [dataOne.id, dataTwo.id];
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.id == lItem.labelId) {
                    valueId = [dataOne.id, dataTwo.id, three.id];
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.id == lItem.labelId) {
                        valueId = [dataOne.id, dataTwo.id, three.id, four.id];
                      }
                    });
                  }
                });
              }
            });
          }
        });
        // labelValue 对应位置上添加
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            labelVal = [...labelVal, valueId];
          }
          return labelVal;
        });
      } else {
        this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
          if (labelIndex == index) {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
          }
          return labelVal;
        });
      }
      console.log(this.labelValue, "ppppppp11111111");
    },
    clickOnceApply(applyStatus) {
      if (applyStatus) {
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          if (!lItem.isSelected) {
            lItem.isSelected = true;
            //  通过labelGroupId找到大模型对应哪一行 改变label
            let index = this.articleLabels.findIndex((aItem) => {
              if (this.$commonJs.getTenantId() == 290) {
                return aItem.id == lItem?.commonLabelBizDTO.labelGroupId;
              }
              return aItem.id == lItem.commonLabelBizDTO.firstPid;
            });
            if (index != -1) {
              console.log(
                index,
                this.articleLabels,
                "11111ppppppppppppp---------->点击了了了",
                lItem
              );
              let item = this.articleLabels[index];
              let valueId = [];
              if (item.contentLabels) {
                item.contentLabels = item.contentLabels;
              }
              // 第一级
              item?.contentLabels?.map((dataOne) => {
                if (dataOne.id == lItem.labelId) {
                  valueId = [dataOne.id];
                }
                // 第二级
                if (dataOne.contentLabels) {
                  dataOne.contentLabels.map((dataTwo) => {
                    if (dataTwo.id == lItem.labelId) {
                      valueId = [dataOne.id, dataTwo.id];
                    }
                    // 第三级
                    if (dataTwo.contentLabels) {
                      dataTwo.contentLabels.map((three) => {
                        if (three.id == lItem.labelId) {
                          valueId = [dataOne.id, dataTwo.id, three.id];
                        }
                        if (three.contentLabels) {
                          three.contentLabels.map((four) => {
                            if (four.id == lItem.labelId) {
                              valueId = [
                                dataOne.id,
                                dataTwo.id,
                                three.id,
                                four.id,
                              ];
                            }
                          });
                        }
                      });
                    }
                  });
                }
              });
              // labelValue 对应位置上添加
              this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
                if (labelIndex == index) {
                  labelVal = [...labelVal, valueId];
                }
                return labelVal;
              });
            }
          }
          return lItem;
        });
      } else {
        console.log("pppp");
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          lItem.isSelected = false;
          this.labelValue = this.labelValue.map((labelVal, labelIndex) => {
            // 循环便利 相等则删除
            labelVal = labelVal.filter((val) => {
              return !val.includes(lItem.labelId);
            });
            return labelVal;
          });
          return lItem;
        });
      }
    },
    visibleChange(val) {
      if (val) {
        //此处可以出来选中下拉选项，清空input搜索值
      }
      this.$nextTick(() => {
        // 添加这段代码
        const $el = document.querySelectorAll(
          ".el-cascader-panel .el-cascader-node[aria-owns]"
        );
        Array.from($el).map((item) => item.removeAttribute("aria-owns"));
      });
    },
    getFormLabelData(form) {
      let newList = []; // 原始数据
      let numList = []; // 选择的id
      // 整合原始数据
      this.articleLabels?.map((item) => {
        // 一级数据
        newList.push(item);
        item?.contentLabels?.map((oneItem) => {
          if (oneItem.contentLabels) {
            // 二级数据
            if (oneItem.contentLabels) {
              oneItem.contentLabels.map((twoItme) => {
                newList.push(twoItme);
                // 三级数据
                if (twoItme.contentLabels) {
                  twoItme.contentLabels.map((threeItem) => {
                    newList.push(threeItem);
                    // 四级数据
                    if (threeItem.contentLabels) {
                      threeItem.contentLabels.map((fourItem) => {
                        newList.push(fourItem);
                        if (fourItem?.contentLabels) {
                          threeItem?.contentLabels.map((fifthItem) => {
                            newList.push(fifthItem);
                          });
                        }
                      });
                    }
                  });
                }
              });
            }
          }
          newList.push(oneItem);
        });
      });
      // 选择的id
      this.labelValue?.map((item) => {
        if (item.length == 2) {
          numList.push(item[1]);
        } else if (item.length == 3) {
          numList.push(item[2]);
        } else if (item.length == 4) {
          numList.push(item[3]);
        } else if (item.length == 5) {
          numList.push(item[4]);
        } else {
          numList.push(item[0]);
        }
      });
      // 新增和回显数据
      form.extensionContentLabels = [];
      newList?.map((item) => {
        numList.map((idItme) => {
          if (item.id == idItme) {
            // todo
            // const { contentLabels, ...itemWithoutContentLabels } = item;
            form.extensionContentLabels.push(item);
          }
        });
      });
    },
    // 创作者端 -------- 获取标签组信息
    async getListContentUserLabels() {
      let res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId || "",
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ getListContentUserLabels ~ res: 343 ", res);
      console.log("======??", res);
      let initData = [];
      if (this.labelType) {
        res.forEach((item) => {
          initData = initData.concat(...item.contentLabels);
        });
      }
      this.articleLabels = this.labelType ? initData : res.data;
      console.log(initData, this.articleLabels, "====---------------->", res);
      this.articleLabels &&
        this.articleLabels.forEach((oneLevel) => {
          oneLevel.valueId = [];
          // if (oneLevel.contentLabels) {
          // oneLevel.contentLabels = oneLevel.contentLabels
          // }
          oneLevel?.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = true;
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel.contentLabels.forEach((three) => {
                  if (three.contentLabels.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel.contentLabels.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four.contentLabels.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
      // 反显
      this.articleLabels?.map((item) => {
        item.valueId = [];
        if (item.contentLabels) {
          item.contentLabels = item.contentLabels;
        }
        // 第一级
        item?.contentLabels?.map((dataOne) => {
          if (dataOne.isChecked) {
            item.valueId.push([dataOne.id]);
          }
          // 第二级
          if (dataOne.contentLabels) {
            dataOne.contentLabels?.map((dataTwo) => {
              if (dataTwo.isChecked) {
                item.valueId.push([dataOne.id, dataTwo.id]);
              }
              // 第三级
              if (dataTwo.contentLabels) {
                dataTwo.contentLabels.map((three) => {
                  if (three.isChecked) {
                    item.valueId.push([dataOne.id, dataTwo.id, three.id]);
                  }
                  if (three.contentLabels) {
                    three.contentLabels.map((four) => {
                      if (four.isChecked) {
                        item.valueId.push([
                          dataOne.id,
                          dataTwo.id,
                          three.id,
                          four.id,
                        ]);
                      }
                    });
                  }
                });
              }
            });
          }
        });
        this.labelValue.push(item);
        console.log(this.labelValue, "labelValue------>");
      });
    },
    // 运营端 -------- 获取审核文章时的标签组和标签信息
    async listContentLabelsForAudit() {
      var res = await request(this.functionIds.getArticleLabel, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.articleId,
        labelType: this.labelType ? this.labelType : undefined,
        labelGroupId: this.labelGroupId
          ? this.labelGroupId
          : this.labelType
          ? this.$route.query.labelGroupId || "782"
          : undefined,
      });
      console.log("🚀 ~ listContentLabelsForAudit ~ res: 449 ", res);
      console.log("======??1", res);
      if (res.code != "1900") {
        let initData = [];
        if (this.labelType) {
          res?.data?.forEach((item) => {
            initData = initData.concat(...item.contentLabels);
          });
        }
        this.articleLabels = this.labelType ? initData : res.data;
        // label
        this.articleLabels?.forEach((oneLevel) => {
          // if (oneLevel.contentLabels) {
          //   oneLevel.contentLabels = oneLevel.contentLabels
          // }
          // 一级
          oneLevel.contentLabels?.forEach((twoLevel, index) => {
            if (twoLevel?.contentLabels?.length > 0) {
              twoLevel.disabled = twoLevel?.contentLabels?.length > 0;
              // 二级
              twoLevel.contentLabels.forEach((threeLevel) => {
                threeLevel?.contentLabels?.forEach((three) => {
                  // 子标签长度为0时，删除改子标签字段
                  if (three?.contentLabels?.length < 1) {
                    three.contentLabels = undefined;
                  }
                });
                // 长度大于零时本级不可选择
                if (threeLevel?.contentLabels?.length > 0) {
                  threeLevel.disabled = true;
                  // 三级
                  threeLevel?.contentLabels?.forEach((three) => {
                    if (three?.contentLabels?.length < 1) {
                      three.contentLabels.forEach((four) => {
                        // 子标签长度为0时，删除改子标签字段
                        if (four?.contentLabels?.length < 1) {
                          four.contentLabels = undefined;
                        }
                      });
                    }
                    // 长度大于零时本级不可选择
                    if (three?.contentLabels?.length > 0) {
                      three.disabled = true;
                      // TODO: 后期更改项 todo 暂时支持到四级，四级后不显示
                      three.contentLabels.forEach((fourLevel) => {
                        fourLevel.contentLabels = undefined;
                      });
                    } else {
                      three.contentLabels = undefined;
                    }
                  });
                } else {
                  threeLevel.contentLabels = undefined;
                  threeLevel.disabled = false;
                }
              });
            } else {
              twoLevel.disabled = false;
              twoLevel.contentLabels = undefined;
            }
          });
        });
        this.articleLabels?.map((item) => {
          item.valueId = [];
          if (item.contentLabels) {
            item.contentLabels = item.contentLabels;
          }
          console.log("======??2", item);
          if (item.isChecked) {
            console.log("======??3", item);
            this.labelValue.push([item.id]);
          }

          // 第一级
          item?.contentLabels?.map((dataOne) => {
            if (dataOne.isChecked) {
              console.log("======??4", dataOne);
              this.labelValue.push([item.id, dataOne.id]);
            }
            // 第二级
            if (dataOne.contentLabels) {
              dataOne.contentLabels.map((dataTwo) => {
                if (dataTwo.isChecked) {
                  this.labelValue.push([item.id, dataOne.id, dataTwo.id]);
                }
                // 第三级
                if (dataTwo.contentLabels) {
                  dataTwo.contentLabels.map((three) => {
                    if (three.isChecked) {
                      this.labelValue.push([
                        item.id,
                        dataOne.id,
                        dataTwo.id,
                        three.id,
                      ]);
                    }
                    if (three.contentLabels) {
                      three.contentLabels.map((four) => {
                        if (four.isChecked) {
                          this.labelValue.push([
                            item.id,
                            dataOne.id,
                            dataTwo.id,
                            three.id,
                            four.id,
                          ]);
                        }
                      });
                    }
                  });
                }
              });
            }
          });
          // this.labelValue.push(item.valueId)
          // [ [], [ [ 101573, 101596, 101600, 101697 ], [ 101573, 101596, 101606 ] ], [], [], [], [], [], [], [ [ 10180103, 101619 ] ], [], [], [], [], [], [], [], [] ]
          // this.labelValue = [ [ 101560, 101561 ], [ 101560, 101565, 101567 ], [ 101560, 101565, 101568 ], [ 101573, 101585 ] ]
          // this.labelValue = this.labelValue
          //   .filter(item => item.length > 0) // 过滤掉空数组
          if (item.valueId.length > 0) {
            console.log(
              "item.valueId.length",
              "ppppppppppppppp111",
              this.largeModelLabels.length,
              this.articleLabels.length
            );
            // 匹配大模型
            this.largeModelLabels = this.largeModelLabels.map((lItem) => {
              if (lItem.commonLabelBizDTO.labelGroupId == item.id) {
                // 从大分组中找到单行
                const findRes = item.valueId?.find((cItem) => {
                  return cItem.includes(lItem.labelId);
                });
                if (findRes) {
                  lItem.isSelected = true;
                }
              }
              return lItem;
            });
          }
          //
        });
      } else {
        this.articleLabels = [];
      }
    },
    getLargeModelForItem(item) {
      if (this.$commonJs.getTenantId() == 290) {
        return this.largeModelLabels.filter(
          (lgModel) => lgModel.commonLabelBizDTO.labelGroupId == item.id
        );
      }
      return this.largeModelLabels.filter(
        (lgModel) => lgModel.commonLabelBizDTO.firstPid == item.id
      );
    },
  },
  watch: {
    largeModelLabelBizDTOS(val) {
      this.largeModelLabels = val;
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp11111111",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
    articleLabels(val) {
      if (val && val.length > 0) {
        console.log(
          "item.valueId.length",
          "ppppppppppppppp22222",
          this.largeModelLabels.length,
          this.articleLabels.length
        );
        // 大模型中是否有已经选中的
        this.largeModelLabels = this.largeModelLabels.map((lItem) => {
          console.log(this.articleLabels, "this.articleLabels,,,,,,,");
          // 找到对应位置
          const index = this.articleLabels.findIndex((aItem) => {
            if (this.$commonJs.getTenantId() == 290) {
              return aItem.id == lItem.commonLabelBizDTO.labelGroupId;
            }
            return aItem.id == lItem.commonLabelBizDTO.firstPid;
          });
          if (index > -1) {
            const changeLabelValue = this.labelValue[index];
            if (changeLabelValue.length > 0) {
              const findRes = changeLabelValue?.find((cItem) => {
                return cItem.includes(lItem.labelId);
              });
              if (findRes) {
                lItem.isSelected = true;
              }
            }
          }

          return lItem;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.eye-gray {
  content: "";
  display: inline-block;
  background: url("~@/assets/eye-gray.png") no-repeat 0 0;
  background-size: 18px 18px;
  width: 18px;
  height: 18px;
  margin-left: -20px;
  margin-top: -15px;
}

// 点击文字选中
.el-cascader-panel .el-checkbox {
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

.el-cascader-node__label {
  margin-left: 10px;
}

:deep(.el-input) {
  width: 400px !important;
}

// 文字过多，省略样式
.content-item p {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

:deep(.content-item) {
  min-width: 100% !important;
  flex-direction: column !important;
  .top-wrap {
    display: flex;
    flex-direction: row;
  }
}

.large-tab-wrap {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // margin-left: 20px;

  .large-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border: 1px solid #ffa400;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    cursor: pointer;
    color: #ffa400;
    margin-bottom: 20px;
    font-size: 14px;
    img {
      position: absolute;
      top: -8px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
    &.selected {
      border: 1px solid rgba(195, 195, 195, 1);
      color: #ffffff;
      background-color: rgba(195, 195, 195, 1);
    }
  }
}
</style>
